import { version } from "./version";

//production:
export const environment = {
  production: true,
  version: version,
  apiUrl: 'https://aviationdirectory.skyharbor.aero/API',
  redirectUrl: 'https://aviationdirectory.skyharbor.aero',
  appRoot: '/',
  backgroundImage: 'assets/images/background/PHX_Sky_Train_hires.jpg',
  missingUserMessage: "Your User Information was not found in the Aviation Directory.",
  missingUserMessage2: "Please submit a service request to be added to the Aviation Directory.",
  missingUserLink: "https://forms.skyharbor.aero/HelpDesk/GeneralRequest",
  missingUserLinkText:"Click Here to create a Service Request",
  replaceStringKeyword: "{fieldvalue}",
  workDaySelectedMessage:"{fieldvalue} is selected as a Work day, Please specify your schedule.",
  workDayNotSelectedMessage:"{fieldvalue} is not selected as Work day,  Please correct your schedule",
  teleworkOfficeSamedayMessage: "{fieldvalue} should be either office day or telework. Same day cannot be office day and telework.",
  noPhotoMesssage : "No profile picture is found in badging system.",
  clickhere: "Please create a service ticket for BAGIS.",
  workdayinstructions: "Note : Office and Telework must be selected on basis of Workdays. Office and Telework can't be on same days.",
  badgingservernotconnected: " Badging Office server is not connected.",
  AuthenticationToken:"XYZYT-12394577659220-239239398329-438KJUYTRTY",
  PayWeek: "03/18/2026",
  OnBoardNewHireLink :"https://apps.gov.powerapps.us/play/e/f670dee6-d9e9-eccf-ac81-2008d1cd7cac/a/5ca2f01e-462d-47a0-80c0-3e3582951297?tenantId=96b9695c-4f0e-42bd-8adf-ba755760346b&hint=f88b3615-0bc2-4b98-90c3-de02e997fee6"
};
